// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"APSlider_sliderWrapper__E2V+k","sliderPrice":"APSlider_sliderPrice__vlDwy","slider":"APSlider_slider__Q-7C6"};